export const CREATE_EDOK_FORM_FAILURE = 'CREATE_EDOK_FORM_FAILURE';

export const createEdokFormFailure = error => ({
    type: CREATE_EDOK_FORM_FAILURE,
    payload: error,
    error: true,
});
